export const HEADING = 'Diabetes details';
